import axios from 'api/axios'

/**
 * Helper class para Planificaciones
 */
export class PlanificacionesHelper {
  /**
   * Crear una nueva planificación
   * @static
   * @sync
   * @param {Object} planificacionData
   * @returns {Promise<Object>}
   */
  static async createPlanificacion(planificacionData) {
    try {
      const { data } = await axios.post('/planificaciones/', planificacionData)
      return data
    } catch (error) {
      throw new Error(error.message)
    }
  }

  /**
   * Actualizar una planificación existente
   * @static
   * @async
   * @param {number} id
   * @param {Object} planificacionData
   * @returns {Promise<Object>}
   */
  static async updatePlanificacion(id, planificacionData) {
    try {
      const { data } = await axios.put(`/planificaciones/${id}/`, planificacionData)
      return data
    } catch (error) {
      throw new Error(error.message)
    }
  }

  /**
   * Obtener una planificación por ID
   * @static
   * @async
   * @param {number} id
   * @returns {Promise<Object>}
   */
  static async getPlanificacionById(id) {
    try {
      const { data } = await axios.get(`/planificaciones/${id}/`)
      return data
    } catch (error) {
      throw new Error(error.message)
    }
  }

  /**
   * Sincronizar pedidos con planificación
   * @static
   * @async
   * @param {number} planificacionId
   * @param {Array<number>} pedidosIds
   * @returns {Promise<Object>}
   */
  static async sincronizarPedidos(planificacionId, pedidosIds) {
    try {
      const { data } = await axios.put(`/planificaciones/bulk/pedidos/`, {
        id_planificacion: planificacionId,
        add_pedidos: pedidosIds,
      })
      return data
    } catch (error) {
      throw new Error(error.message)
    }
  }

  /**
   * Marcar un pedido en una planificación
   * @static
   * @async
   * @param {number} planificacionId
   * @param {number} pedidoId
   * @returns {Promise<Object>}
   */
  static async marcarPedido(planificacionId, pedidoId) {
    try {
      const { data } = await axios.post('/planificaciones/pedidos/', {
        id_planificacion: planificacionId,
        id_linea_pedido: pedidoId,
      })
      return data
    } catch (error) {
      throw new Error(error.message)
    }
  }

  /**
   * desmarcar un pedido de una planificación
   * @static
   * @async
   * @param {number} idPlanificacionPedido
   * @param {number} pedidoId
   * @returns {Promise<void>}
   */
  static async desmarcarPedido(idPlanificacionPedido) {
    try {
      await axios.delete(`/planificaciones/pedidos/${idPlanificacionPedido}/`)
    } catch (error) {
      throw new Error(error.message)
    }
  }

  /**
   * Eliminar una planificación completa
   * @static
   * @async
   * @param {number} id
   * @returns {Promise<void>}
   */
  static async deletePlanificacion(id) {
    try {
      await axios.delete(`/planificaciones/${id}/`)
    } catch (error) {
      throw new Error(error.message)
    }
  }

  /**
   * Añadir o borrar pedidos en bulk por filtros de fecha
   * @static
   * @async
   * @param {number} idPlanificacion - ID de la planificación
   * @param {string} operacion - "A" para añadir, "B" para borrar
   * @param {Object} filtros - Filtros de búsqueda
   * @param {string} filtros.fechaDesde - Fecha desde (formato YYYY-MM-DD)
   * @param {string} filtros.fechaHasta - Fecha hasta (formato YYYY-MM-DD)
   * @param {string} filtros.seccion - Sección (opcional)
   * @returns {Promise<Object>}
   */
  static async bulkPedidosPorFiltros(idPlanificacion, operacion, filtros) {
    try {
      const payload = {
        id_planificacion: idPlanificacion,
        operacion: operacion,
        fecha_entrega_desde: filtros.fechaDesde || null,
        fecha_entrega_hasta: filtros.fechaHasta || null,
        seccion: filtros.seccion || null,
      }
      const { data } = await axios.post('/planificaciones/pedidos/bulk/', payload)
      return data
    } catch (error) {
      throw new Error(error.message)
    }
  }
}
